export default "__VITE_ASSET__92ad0307__"